// The import card in the platform agent's panel (D12): before a menu import or a copy runs, while it runs, and how it
// ended. Wording from the Amigo for menus design's copy sheet (Import card, Not live yet, Buttons, Importing, Failed,
// What to try, the 5 reasons, Went live, Import done).
export default {
  title: {
    import: 'Importar o menu de {{platform}}',
    copy: 'Copiar o menu de {{restaurant}}',
    data: 'Criar o menu que o Amigo leu',
  },
  // A menu Amigo read from a file or the chat (QA36): a change card with each dish, before it is created.
  contents: {
    title: 'Criar {{categories}} e {{dishes}}',
    from: {
      file: 'O Amigo leu isto do seu ficheiro',
      chat: 'O Amigo leu isto da nossa conversa',
    },
    summary: 'Cria {{categories}} e {{dishes}}. Verifique cada prato com o respetivo preço na lista abaixo.',
    price: 'Preço',
    tax_category: 'Categoria fiscal',
    no_price: 'Ainda sem preço',
    default_tax: 'A sua taxa padrão',
    // Once approved: the import's run, in the words of creating a menu.
    creating: 'A criar {{categories}} e {{dishes}}…',
    done: 'O menu foi criado: {{categories}}, {{dishes}} e {{option_groups}} estão no menu de {{restaurant}}',
    done_plain: 'O menu foi criado',
  },
  waiting: 'A aguardar aprovação',
  labels: {
    from: 'De',
    to: 'Para',
    menu: 'Menu',
    brings_over: 'Importa',
  },
  from: {
    // "Lieferando · lieferando.de/speisekarte/pizzeria-lupo-koeln"
    platform: '{{platform}} · {{link}}',
    // "Pizzeria Lupo · 12 categories, 140 dishes"
    restaurant: '{{restaurant}} · {{categories}}, {{dishes}}',
    // "The menu Amigo read · 2 categories, 4 dishes" (B19)
    data: 'O menu que o Amigo leu · {{categories}}, {{dishes}}',
  },
  to: {
    only_location: '{{name}}, o seu único local',
    brand_one: 'Menu da marca {{name}}, apenas um local',
    brand_other: 'Menu da marca {{name}}, todos os {{count}} locais',
  },
  menu: {
    empty: 'Vazio, por isso este passa a ser o menu',
    adds: 'Acrescenta ao menu atual ({{size}}). Os pratos com o mesmo nome são atualizados; nada é removido.',
    // The menu's name and size: "Speisekarte: 12 categories, 140 dishes".
    size_named: '{{name}}: {{categories}}, {{dishes}}',
    size: '{{categories}}, {{dishes}}',
  },
  counts: {
    categories_one: '{{count}} categoria',
    categories_other: '{{count}} categorias',
    dishes_one: '{{count}} prato',
    dishes_other: '{{count}} pratos',
    option_groups_one: '{{count}} grupo de opções',
    option_groups_other: '{{count}} grupos de opções',
  },
  // What an import brings over, as one list: "Categories, dishes, prices, option groups, photos, and allergens and
  // nutrition where Lieferando has them". Each item starts lowercase; the list's first letter is capitalised.
  brings_over: {
    everything: 'Tudo, tal como está',
    categories: 'categorias',
    dishes: 'pratos',
    descriptions: 'descrições',
    prices: 'preços',
    option_groups: 'grupos de opções',
    photos: 'fotos',
    where: {
      allergens_nutrition: 'alergénios e informação nutricional, quando {{platform}} os tem',
      allergens: 'alergénios, quando {{platform}} os tem',
      nutrition: 'informação nutricional, quando {{platform}} a tem',
    },
  },
  not_live:
    '{{restaurant}} ainda não está ativo: os clientes veem o menu na ligação da loja, mas não podem encomendar.',
  buttons: {
    import: 'Importar',
    copy: 'Copiar',
    cancel: 'Cancelar',
  },
  hint: 'Ou responda abaixo para alterar algo.',
  action_failed: 'Não foi possível concluir, por isso nada foi alterado. Tente novamente dentro de instantes.',
  // Shop's 409 codes when Import is pressed again while the first one runs (QA125).
  refused: {
    already_running: 'Esta importação já está em curso. O Amigo avisa-o aqui quando terminar.',
    already_applying: 'Está a ser aplicado neste momento. Aguarde um instante até terminar.',
  },
  importing: {
    title: {
      import: 'A importar de {{platform}}…',
      copy: 'A copiar de {{restaurant}}…',
    },
    started: 'Iniciado {{time}}',
    queued: 'A iniciar…',
    hint: 'Isto pode demorar alguns minutos. Pode fechar o painel ou continuar a trabalhar; publicarei o resultado aqui.',
  },
  done: {
    // What is on the menu now, while the card is the only result ({{categories}} … are `counts`): "The import from
    // Lieferando is done: 12 categories, 140 dishes and 38 option groups are on Pizzeria Lupo's menu".
    title: {
      import:
        'A importação de {{platform}} está concluída: {{categories}}, {{dishes}} e {{option_groups}} estão no menu de {{restaurant}}',
      copy: 'A cópia está concluída: {{categories}}, {{dishes}} e {{option_groups}} estão no menu',
    },
    // Without counts, or once Amigo's result under the card says them.
    title_plain: {
      import: 'A importação de {{platform}} foi concluída',
      copy: 'A cópia foi concluída',
    },
    finished: 'Concluído {{time}}',
    // The page in the sidebar's words: "Open Menu → Manage menus".
    open: 'Abrir {{page}}',
  },
  failed: {
    title: {
      import: 'Não foi possível importar: {{reason}}',
      copy: 'Não foi possível copiar: {{reason}}',
    },
    title_plain: {
      import: 'Não foi possível importar',
      copy: 'Não foi possível copiar',
    },
    nothing: {
      import: 'Nada foi importado.',
      copy: 'Nada foi copiado.',
    },
    what_to_try: 'O que tentar:',
    retry: 'Tentar novamente',
    reasons: {
      listing_not_found: {
        title: 'anúncio não encontrado',
        text: '{{platform}} não tem nenhum restaurante nesta ligação. Nada foi importado.',
        try: 'Abra a ligação num navegador para confirmar que mostra o menu do restaurante e envie-a novamente.',
      },
      listing_not_supported: {
        title: 'anúncio não suportado',
        text: 'Esta é uma página de cadeia de {{platform}}, não o menu de um restaurante, por isso não a posso importar. Nada foi importado.',
        try: 'Envie a ligação da página de menu do próprio restaurante em {{platform}}.',
      },
      platform_failed: {
        title: '{{platform}} falhou',
        text: '{{platform}} não respondeu, por isso nada foi importado.',
        try: 'Tente novamente dentro de alguns minutos.',
      },
      // A copy from another restaurant that failed on our side: there is no platform to name.
      copy_failed: {
        title: 'a cópia falhou',
        text: 'A cópia não foi concluída, por isso nada foi copiado.',
        try: 'Tente novamente dentro de alguns minutos.',
      },
      // {{listing}} and {{currency}} are currencies with their sign: "British pounds (£)", "euros (€)". {{page}} is the
      // sidebar's My info.
      currency_mismatch: {
        title: 'a moeda não corresponde',
        text: 'O anúncio está em {{listing}}, mas {{restaurant}} usa {{currency}}. Nada foi importado.',
        try: 'Envie um anúncio em {{currency}} ou verifique primeiro a moeda do restaurante em {{page}}.',
        text_other: 'O anúncio está numa moeda diferente da de {{restaurant}}. Nada foi importado.',
        try_other: 'Envie um anúncio na moeda do restaurante ou verifique primeiro a moeda em {{page}}.',
      },
      link_paused: {
        title: 'ligação em pausa',
        text: 'Esta ligação falhou 3 vezes seguidas, por isso as importações a partir dela estão em pausa até {{time}}. Nada foi importado.',
        text_no_until:
          'Esta ligação falhou 3 vezes seguidas, por isso as importações a partir dela estão em pausa por agora. Nada foi importado.',
        try: 'Envie uma ligação de outra plataforma ou copie o menu de outro restaurante.',
      },
    },
  },
  stopped: {
    title: 'Interrompido: {{restaurant}} ficou ativo',
    nothing: {
      import: 'Nada foi importado',
      copy: 'Nada foi copiado',
    },
  },
  // The card folded to one line.
  line: {
    cancelled: 'Cancelado',
    expired: 'Expirado',
    replaced: 'Substituído',
  },
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Aprovado.',
    cancelled: 'Cancelado.',
    retried: 'Tentou-se novamente.',
  },
};
